<template>
    <div id="index">
        <div class="ui container">
            <div class="ui stackable grid container">
                <div class="seven wide column">
                    暫時無任何設定
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
}
</script>
